import { DealerLocationID } from "./DealerLocation";
import { UserID } from "./User";

export type PlanItPlanningMechanicID = number;

export interface PlanItPlanningMechanic {
  created_on: string;
  updated_on: string;
  planit_planning_mechanic_id: PlanItPlanningMechanicID;
  planit_code: string;
  planit_mechanic_name: string;
  planit_dealer_location_id: DealerLocationID;
  planit_user_id: UserID | null;
}
